import { useTemplateRef } from 'vue';
import type BaseModal from '@lmt-rpb/BaseModal/BaseModal.vue';

/**
 * @param refkey the name of the template ref
 * @returns a tuple with two functions: openModal and closeModal.
 */
export function useBaseModal(refkey: string) {
	const modalRef = useTemplateRef<InstanceType<typeof BaseModal>>(refkey);

	const openModal = () => {
		modalRef.value?.openModal();
	};
	const closeModal = () => {
		modalRef.value?.closeModal();
	};

	return [openModal, closeModal] as const;
}
